export default __webpack_public_path__ + "static/media/banner-a.1273e84c.jpg";